import { SVGIcon } from '@superops/super-icons';
import { TextStyle } from '@superops/ui-design-system';
import React from 'react';

const TextContainer = ({ title, content }) => {
  return (
    <div className="mb20">
      {title && (
        <div className="mb10">
          <TextStyle weight="Medium">{title} :</TextStyle>
        </div>
      )}

      {content && (
        <div>
          <TextStyle>{content}</TextStyle>
        </div>
      )}
    </div>
  );
};

const TicketCategorySummary = (props) => {
  const { data, content } = props;
  return (
    <div className="text-white">
      <div className="mb-10 flex g10">
        <div className="flex">
          <SVGIcon name={data?.headingIcon} />
        </div>

        <div className="text-white">
          <TextStyle weight="medium">{data?.headingText}</TextStyle>
        </div>
      </div>

      <div className="ai-content-container-max-height scroll">
        {content?.summary && (
          <TextContainer title="Summary" content={content?.summary} />
        )}

        {content?.groupSummaries && (
          <>
            {content?.groupSummaries?.map((el) => {
              return <TextContainer title={el?.name} content={el?.summary} />;
            })}
          </>
        )}

        {content?.solution && (
          <TextContainer title="Solution" content={content?.solution} />
        )}
      </div>
    </div>
  );
};

export default TicketCategorySummary;
